import React from 'react';
import createSvgIcon from '@material-ui/icons/utils/createSvgIcon';

export default createSvgIcon(
  <path d="M16.9999 2C17.5522 2 17.9999 2.44772 17.9999 3C17.9999 3.51284 17.6139 3.93551 17.1165 3.99327L16.9999 4H9.0439L14.7893 11.3861C15.042 11.7111 15.0673 12.1531 14.8651 12.5016L14.7893 12.6139L9.0439 20H16.9999C17.5127 20 17.9354 20.386 17.9932 20.8834L17.9999 21C17.9999 21.5128 17.6139 21.9355 17.1165 21.9933L16.9999 22H6.9999C6.20558 22 5.74296 21.1279 6.14689 20.4774L6.21055 20.3861L12.7329 12L6.21055 3.61394C5.72288 2.98694 6.12722 2.08639 6.88874 2.00581L6.9999 2H16.9999Z" />,
  'Functions'
);
